import React from "react";
import { Link, useNavigate } from "react-router-dom";
import HelmetWrapper from "../HelmetWrapper";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <HelmetWrapper title="WTF: Page Not Found">
      <div>
        <div className="flex-k js-center-k items-center-k flex-col-k h-75vh-k">
          <h1 className="fs-900-k bolder-text">404</h1>
          <p className="fs-med-k">
            The page you were looking for doesn't exist!
          </p>
          <Link
            onClick={navigate("/")}
            className="decoration-none-k fs-normal-k"
          >
            {"< Return Home"}
          </Link>
        </div>
      </div>
    </HelmetWrapper>
  );
};

export default NotFound;
